var _rect, _rect2, _path, _rect3, _rect4, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 80,
    viewBox: "0 0 87 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 15,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 78,
    height: 78,
    rx: 15,
    stroke: "#D0D5DD",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8 61H28.1732C26.7596 61 26.0528 61 25.7256 60.7205C25.4416 60.4779 25.2909 60.1141 25.3202 59.7418C25.3539 59.3127 25.8537 58.8129 26.8533 57.8134L46.6935 37.9732C47.6175 37.0492 48.0795 36.5871 48.6123 36.414C49.0809 36.2618 49.5857 36.2618 50.0544 36.414C50.5871 36.5871 51.0492 37.0492 51.9732 37.9732L61 47V49.8M49.8 61C53.7204 61 55.6806 61 57.1779 60.237C58.4951 59.5659 59.5659 58.4951 60.237 57.1779C61 55.6806 61 53.7204 61 49.8M49.8 61H30.2C26.2796 61 24.3194 61 22.8221 60.237C21.5049 59.5659 20.4341 58.4951 19.763 57.1779C19 55.6805 19 53.7204 19 49.8V30.2C19 26.2796 19 24.3194 19.763 22.8221C20.4341 21.5049 21.5049 20.4341 22.8221 19.763C24.3194 19 26.2796 19 30.2 19H49.8C53.7204 19 55.6805 19 57.1779 19.763C58.4951 20.4341 59.5659 21.5049 60.237 22.8221C61 24.3194 61 26.2796 61 30.2V49.8M36.5 31.8333C36.5 34.4107 34.4107 36.5 31.8333 36.5C29.256 36.5 27.1667 34.4107 27.1667 31.8333C27.1667 29.256 29.256 27.1667 31.8333 27.1667C34.4107 27.1667 36.5 29.256 36.5 31.8333Z",
    stroke: "#E4E7EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 49,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 49,
    width: 30,
    height: 30,
    rx: 15,
    stroke: "#D0D5DD",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0003 54.667V73.3337M61.667 64.0003H80.3337",
    stroke: "#05954E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupAdd);
export default __webpack_public_path__ + "static/media/group-add.e85097eca059fd0d407539923ca17554.svg";
export { ForwardRef as ReactComponent };